import { useEffect } from 'react';

export function LottiePlayer({ url, lottieRef }) {
  useEffect(() => {
    let player;
    if (lottieRef.current) {
      const lottie = window?.lottie;
      player = lottie?.loadAnimation({
        container: lottieRef.current,
        renderer: 'canvas',
        loop: false,
        path: url,
      });
    }
    return () => {
      player?.destroy();
    };
  });
}

export default LottiePlayer;
